module.exports = __webpack_public_path__ + "img/speaker.82ec732d.svg";